import React from 'react';
import { IconProps } from '.';

const SvgCrop = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='M5.25 5.25V2h1.5v3.25h12v12H22v1.5h-3.25V22h-1.5v-3.25h-12v-12H2v-1.5h3.25Zm1.5 1.5v10.5h10.5V6.75H6.75Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgCrop;
